// ALL DATES RETURNED IFORM THESE FUNCTIONS ARE BASED ON ACCOUNTING DATES (05:30 => 05:29)

// TODO: All this needs to be removed and use useDates hook instead to avoid timezone issues.

import dayjs, { OpUnitType } from 'dayjs';
import minMax from 'dayjs/plugin/minMax';

dayjs.extend(minMax);

export const timezoneDate = (date?: Date | string) => dayjs(date).tz();

export const setTimeToAccountingStart = (date: dayjs.Dayjs): dayjs.Dayjs =>
  date.set('hours', 5).set('minute', 30).set('second', 0);

export const setTimeToAccountingEnd = (date: dayjs.Dayjs): dayjs.Dayjs =>
  date.add(1, 'day').set('hours', 5).set('minute', 29).set('second', 59);

// Returns date at 5:30 AM
export const getStartDate = (date: Date | string) => {
  return setTimeToAccountingStart(timezoneDate(date));
};

// Returns the next day of date at 5:29:59 AM
// This is considered the end of the accounting day
export const getEndDate = (date: Date | string) => {
  return setTimeToAccountingEnd(timezoneDate(date));
};

export const getToday = () => {
  return timezoneDate().toDate();
};

export const getYesterday = (date?: Date | string) => {
  return timezoneDate(date).subtract(1, 'day').toDate();
};

export const getLastWeek = (date?: Date | string) => {
  return timezoneDate(date).subtract(1, 'week').toDate();
};

export const getStartOfWeek = (date?: Date | string) => {
  return timezoneDate(date).startOf('isoWeek').toDate();
};

export const getAccountingStartOfWeek = (date?: Date | string) => {
  return setTimeToAccountingStart(timezoneDate(date).startOf('isoWeek')).toDate();
};

export const getEndOfWeek = (date?: Date | string) => {
  return timezoneDate(date).endOf('isoWeek').toDate();
};

export const getAccountingEndOfWeek = (date?: Date | string) => {
  return setTimeToAccountingEnd(timezoneDate(date).endOf('isoWeek')).toDate();
};

export const getLastMonth = (date?: Date | string) => {
  return timezoneDate(date).subtract(1, 'month').toDate();
};

export const getStartOfMonth = (date?: Date | string) => {
  return timezoneDate(date).startOf('month').hour(5).toDate();
};

export const getAccountingStartOfMonth = (date?: Date | string) => {
  return setTimeToAccountingStart(timezoneDate(date).startOf('month')).toDate();
};

export const getEndOfMonth = (date?: Date | string) => {
  return timezoneDate(date).endOf('month').toDate();
};

export const getLastYear = (date?: Date | string) => {
  return timezoneDate(date).subtract(1, 'year').toDate();
};

export const getStartOfCurrentYear = () => {
  return timezoneDate().startOf('year').toDate();
};

// First available date for orders in Order History
export const getFirstAvailableDate = () => {
  return timezoneDate('2017-04-01').toDate();
};

export const getDate = (date: string) => {
  return timezoneDate(date).toDate();
};

export const getMaxDate = (maxDate: Date, date: Date) => {
  // Since timezones are different, and want to compare the dates only without timezone converting the hours wrongly
  // we set the hours to 5:00 AM
  date.setHours(5);
  return dayjs.max(timezoneDate(maxDate), timezoneDate(date)).toDate();
};

export const getMinDate = (minDate: Date, date: Date) => {
  return dayjs.min(timezoneDate(minDate), timezoneDate(date)).toDate();
};

export const getCurrentPeriod = (unitPeriod: OpUnitType) => {
  return {
    startDate: timezoneDate().startOf(unitPeriod).toDate(),
    endDate: getToday(),
  };
};

export const getLastPeriod = (unitPeriod: OpUnitType) => {
  return {
    startDate: timezoneDate().subtract(1, unitPeriod).startOf(unitPeriod).toDate(),

    endDate: timezoneDate().subtract(1, unitPeriod).endOf(unitPeriod).toDate(),
  };
};

export const formatDate = (date: Date | string, format: string) => {
  return timezoneDate(date).format(format);
};

export const getPreviousDate = (date: Date | string) => {
  return timezoneDate(date).toDate();
};
export const getNextDate = (date: Date | string, disableFuture: boolean) => {
  if (disableFuture && dayjs(date).isSame(dayjs().add(-1, 'day'), 'day'))
    return timezoneDate(date).toDate();

  return timezoneDate(date).add(1, 'day').toDate();
};

export const getMonth = (monthIndex: number) => {
  return timezoneDate().month(monthIndex).toDate();
};
